<template>
    <div class="columnar">
        <div :id="echarts" :style="{width: '100%', 'height': height}"></div>
    </div>
</template>

<script>
    var echarts = require('echarts');
    export default {
        name: "contrast",
        props: {
            height: {
                type: String,
                default: '486px'
            },
            barWidth:{
                type: String,
                default: '34'
            },
            barGap:{
                type: String,
                default: '0'
            },
            grid:{
                typy:Object,
                default() {
                    return {
                        top: '10%',
                        left: '8%',
                        right: '0',
                        bottom:'9%',
                        containLabel: true
                    }
                }
            },
            barCategoryGap:{
                type: String,
                default: '0'
            },
            seriesData:{
                type:Object,
                default() {
                    return { title:'',xAxisData:[],yAxisName:'',estimateData:[],actualData:[],legendData:[],seriesName:[] }
                }
            }
        },
        data(){
            return{

            }
        },
		mounted() {
			console.log("dadada")
			this.actualData
		},
        methods:{
            drawColumnar(){
			//	console.log("dadada")
				//this.actualData
                let myChart = echarts.init(document.getElementById(this.echarts));
                let option = {
                    title: {
                        text: this.seriesData.title,
                        left: '50%',
                        bottom: '0',
                        textStyle: {
                            color: '#fff',
                            fontSize: 16,
                            align: 'center'
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        textStyle: {
                            color: '#fff',
                            width: 240,
                            fontSize: '14'
                        },
                        itemGap: 24, // 设置legend的间距
                        itemWidth: 20, // 设置宽度
                        itemHeight: 20, // 设置高度
                        top:0,
                        right:'0',
                        data: this.seriesData.legendData
                    },
                    grid: this.grid,
                    xAxis: {
                        type: 'category',
                        axisLabel:{
                            textStyle:{
                                color:'#fff'
                            }
                        },
                        data: this.seriesData.xAxisData
                    },
                    yAxis: {
                        name: this.seriesData.yAxisName,
                        type: 'value',
                        axisLine: {show:true},
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisLabel:{
                            textStyle:{
                                color:'#fff'
                            }
                        },
                        nameTextStyle:{
                            color:"#fff",
                            fontSize:11,
                            padding:[0, 50, 0, 0]
                        },
                    },
					series:this.seriesData.actualData
                 /*   series: [
                       
                        {
                            name: '耙耙柑',
                            type: 'bar',
							barWidth : '80',
                            stack: 'estimate',
                            emphasis: {
                                focus: 'series'
                            },
                            data: [220,100]
                        },
                        {
                            name: '金桔',
                            type: 'bar',
							barWidth : '80',
                            stack: 'estimate',
                            emphasis: {
                                focus: 'series'
                            },
                            data: [50,300]
                        },
                    ] */
                };
                myChart.setOption(option);
            },
        },
        watch: {
            seriesData: {
                deep: true,
                handler: () => this.seriesData
            }
        },
        mounted() {
            this.drawColumnar();
            window.addEventListener("resize", this.drawColumnar);

        },
        beforeDestroy() {
            window.removeEventListener("resize", this.drawColumnar);
        },
        computed: {
            echarts() {
                return 'echarts' + Math.random() * 100000;
            }
        },
    }
</script>

<style scoped>

</style>
